<template>
  <svg
    xmlns="http://www.w3.org/2000/svg"
    xmlns:xlink="http://www.w3.org/1999/xlink"
    fill="none"
    version="1.1"
    width="12"
    height="12"
    viewBox="0 0 12 12"
  >
    <g style="mix-blend-mode: passthrough">
      <g style="mix-blend-mode: passthrough">
        <path
          d="M3.996,1.7459891710281372C3.92575,1.8242391710281372,3.890625,1.9102391710281372,3.890625,2.0039891710281372C3.890625,2.0977391710281372,3.92575,2.179739171028137,3.996,2.2499891710281372C3.996,2.2499891710281372,7.652245000000001,5.9999941710281375,7.652245000000001,5.9999941710281375C7.652245000000001,5.9999941710281375,3.996,9.749994171028137,3.996,9.749994171028137C3.92575,9.820264171028137,3.890625,9.902244171028137,3.890625,9.995994171028137C3.890625,10.089744171028137,3.92575,10.171714171028137,3.996,10.241994171028137C4.06625,10.312264171028136,4.14825,10.347364171028136,4.242,10.347364171028136C4.33575,10.347364171028136,4.41775,10.316094171028137,4.4879999999999995,10.253614171028136C4.4879999999999995,10.253614171028136,8.366995,6.257614171028137,8.366995,6.257614171028137C8.437255,6.187364171028137,8.472375,6.101364171028137,8.472375,5.999614171028137C8.472375,5.897864171028138,8.437255,5.811864171028137,8.366995,5.741614171028138C8.366995,5.741614171028138,4.4879999999999995,1.7456141710281372,4.4879999999999995,1.7456141710281372C4.41775,1.6831141710281372,4.33575,1.6518641710281372,4.242,1.6518641710281372C4.14825,1.6518641710281372,4.06625,1.6831141710281372,3.996,1.7456141710281372C3.996,1.7456141710281372,3.996,1.7459891710281372,3.996,1.7459891710281372C3.996,1.7459891710281372,3.996,1.7459891710281372,3.996,1.7459891710281372Z"
          fill="currentColor"
        />
      </g>
    </g>
  </svg>
</template>
<script lang="ts">
import type { DefineComponent } from 'vue'
export default {
  name: 'SmallArrowRight',
} as DefineComponent
</script>
